import React, {
  createContext,
  useContext,
  useState,
} from "react";

interface AuthenticationType {
  token: string | null;
  userID: string | null;  
email:string|null;
  role: string | null;


  isAuthenticated: boolean;

  login: (
    token: string,
    userID: string,
    email:string,
    role: string,
   ) => void;

  logout: () => void;
}

const AuthContext = createContext<
  AuthenticationType | undefined
>(undefined);

export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {

  const [token, setToken] = useState(
    localStorage.getItem("token")
  );

  const [role, setRole] = useState(
    localStorage.getItem("role")
  );

  const [userID, setUserID] = useState(
    localStorage.getItem("userID")
  );  
  const [email, setEmail] = useState(
    localStorage.getItem("email")
  );  

  const login = (
    token: string,
    userID: string,  
    email:string,
    role: string,
  ) => {

    setToken(token);
    setRole(role);
    setEmail(email);
    setUserID(userID);
  

    localStorage.setItem("token", token);

    localStorage.setItem("role", role);

    localStorage.setItem("userID", userID);
    localStorage.setItem("email", email);
  };

  const logout = () => {

    setToken(null);
    setRole(null);
    setUserID(null);   
localStorage.removeItem("token");
localStorage.removeItem("role");
localStorage.removeItem("userID");
localStorage.removeItem("email");
    localStorage.clear();
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        userID, 
        email,       
        role,
        login,
        logout,
        isAuthenticated: !!token,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {

  const context = useContext(AuthContext);

  if (!context) {
    throw new Error(
      "useAuth must be used within AuthProvider"
    );
  }

  return context;
};